const TUTORIAL_STEPS = [
    // Step 1: Sidebar welcome
    {
        target: '[data-tour="sidebar"]',
        title: 'Welcome to Multiply!',
        content: 'Multiply is your AI-powered sales training platform. Murphy, your AI coach, will watch your practice recordings, grade your performance, and give you detailed feedback to help you improve. Use this sidebar to navigate between sections.',
        placement: 'right-start',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 2: Stats overview
    {
        target: '[data-tour="stats-overview"]',
        title: 'Your Progress',
        content: 'Track your training at a glance: total sessions completed, your current weekly streak, and progress toward your weekly practice goal.',
        placement: 'bottom',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 3: Training grid
    {
        target: '[data-tour="training-grid"]',
        title: 'Training Cards',
        content: 'These are your core training types. Standard mode is a straight-through pitch recording. Interactive mode adds Murphy as a live participant who interrupts with questions, just like a real prospect would. The more you practice, the better you get!',
        placement: 'top',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 4: First training card
    {
        target: '[data-tour="training-card-first"]',
        title: 'Start a Recording',
        content: 'Click "Record Standard" for a straight pitch, or "Record Interactive" to practice with Murphy asking questions mid-presentation. After each recording, Murphy analyzes your pitch against your company\'s messaging and gives you a grade with specific feedback on what to improve.',
        placement: 'right',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 5: Response training
    {
        target: '[data-tour="response-training"]',
        title: 'Response Training',
        content: 'These are your defensive training modes. Messaging Defense generates realistic prospect objections from your company profile so you can practice thinking on your feet. Objection Handling fires Q&A library questions at you. Document Defense lets you upload any document and Murphy tests your knowledge of it.',
        placement: 'top',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 6: My Reports nav -> navigates to reports
    {
        target: '[data-tour="nav-my-reports"]',
        title: 'My Reports',
        content: 'After each recording, Murphy generates a detailed assessment with a grade, positives, and areas for improvement. My Reports is where you review all your past assessments and track your progress over time.',
        placement: 'right',
        page: '/dashboard',
        navigateAfter: '/my-assessments-report',
        disableBeacon: true,
    },
    // Step 7: Reports page content
    {
        target: '[data-tour="reports-page"]',
        title: 'Assessment History',
        content: 'Click any assessment to see Murphy\'s full feedback: what you did well, what to improve, and your grade. Green means great (65+), yellow means good (50-64), and red means keep practicing. Your goal is to turn those reds and yellows into greens!',
        placement: 'right',
        disableScrolling: true,
        page: '/my-assessments-report',
        disableBeacon: true,
    },
    // Step 8: Company nav -> navigates to company
    {
        target: '[data-tour="nav-company"]',
        title: 'Company Info',
        content: 'This is your company\'s background, differentiators, competitors, and prospect profile. Murphy uses this information to grade your pitches, so these are the key points you should be covering in your recordings.',
        placement: 'right',
        page: '/my-assessments-report',
        navigateAfter: '/company',
        disableBeacon: true,
    },
    // Step 9: Company page content
    {
        target: '[data-tour="company-page"]',
        title: 'Company Overview',
        content: 'This is the information you need to become conversationally confident in. Background, differentiators, addressable problems, competitors, and prospect profile are all used when Murphy grades your pitches.',
        placement: 'right',
        disableScrolling: true,
        page: '/company',
        navigateAfter: '/offerings',
        disableBeacon: true,
    },
    // Step 10: Offerings page
    {
        target: '[data-tour="offerings-page"]',
        title: 'Offerings',
        content: 'These are your products and services with their key differentiators. Murphy references this content when grading your pitches to check whether you\'re covering the right talking points for each offering.',
        placement: 'right',
        disableScrolling: true,
        page: '/offerings',
        navigateAfter: '/objection-handling',
        disableBeacon: true,
    },
    // Step 11: Objection Handling page
    {
        target: '[data-tour="qa-page"]',
        title: 'Objection Handling',
        content: 'This is your library of common objections and ideal responses. Murphy uses these during interactive sessions to test you with real objections. At higher training levels, Murphy will fire these at you mid-pitch to simulate a real prospect.',
        placement: 'right',
        disableScrolling: true,
        page: '/objection-handling',
        disableBeacon: true,
    },
    // Step 12: Training Hub nav
    {
        target: '[data-tour="nav-train"]',
        title: 'Training Hub',
        content: 'The Training Hub has all session types: Pitch Training (Levels 1-2), Messaging Defense, Objection Handling, and Document Defense. Start with Level 1 Elevator Pitch and work your way up!',
        placement: 'right',
        page: '/objection-handling',
        disableBeacon: true,
    },
    // Step 13: Final -> back to dashboard
    {
        target: '[data-tour="nav-dashboard"]',
        title: 'You\'re Ready!',
        content: 'That\'s the tour! Head to your Dashboard and start your first recording. Tip: begin with an Elevator Pitch. It\'s the quickest way to get your first grade from Murphy. Good luck!',
        placement: 'right',
        page: '/objection-handling',
        navigateAfter: '/dashboard',
        isLastStep: true,
        disableBeacon: true,
    },
];

export default TUTORIAL_STEPS;
